import { render, staticRenderFns } from "./AttachmentDocument.vue?vue&type=template&id=0354b88e&scoped=true"
import script from "./AttachmentDocument.vue?vue&type=script&lang=js"
export * from "./AttachmentDocument.vue?vue&type=script&lang=js"
import style0 from "./AttachmentDocument.vue?vue&type=style&index=0&id=0354b88e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0354b88e",
  null
  
)

export default component.exports